import { IAddress } from 'src/app/models/address';
import { Member } from 'src/app/models/member';

import {
    EntityType,
    IAvailableInterview,
    InterviewGlobalMetadata,
    InterviewOrchestrationTypes,
    InterviewType,
} from './interview-handler.models';

export interface AvailableInterviewRequest {
    address: IAddress;
    tenantId: string;
    member: Member;
    interviewType: InterviewType;
    entityType: EntityType;
    entityId: string;
}

export interface IDocumentRequest {
    interview: IAvailableInterview;
    entityId: string;
    entityType: string;
}

export enum AssessmentType {
    Eligibility = 'Eligibility',
    Enrollment = 'Enrollment',
    Qualification = 'Qualification',
    Education = 'Education',
    Document = 'Document'
}

export interface InterviewOrchestrationRequest {
    orchestration: {
        mode: 'Manual';
        type: InterviewOrchestrationTypes;
    };
    interview: InterviewGlobalMetadata;

}


export interface InterviewOrchestration {
    externalId: string;
    orchestrationId: string;
}


export class AvailableInterviews extends Array<IAvailableInterview> {
    constructor(input: IAvailableInterview[]) {
        super();
        try {
            (input || []).forEach(item => {
                this.push(item);
            });
        } catch (ex) {

        }
    }
}

export interface IInterviewConfig {
    id: string;
    packageName: string;
    packageVersion: string;
    entityType: string;
    completion: number;
    entityId?: string;
    dataProvider?: string;
    summaryComponent?: string;
    type: string;
    context: any;
    byPassToSummary?: boolean;
}
